/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { models_EmailHoldRule } from './models_EmailHoldRule';
import type { models_ExitFee } from './models_ExitFee';
import type { models_InvoiceDueDateRule } from './models_InvoiceDueDateRule';
import type { models_Service } from './models_Service';
import type { models_SettlingInBilling } from './models_SettlingInBilling';
export type models_BillingSettings = {
    /**
     * AnnualConfirmationIncludeExtras includes the additional services
     * (child_extras lines: EINSCH, EMPFEHL, MISC, LEGACY, SETTLING_IN,
     * TERMINATION, credits included) in the annual confirmation's care amount
     * (#1976). Extra care days always count and courses never do, whatever the
     * switch says. Stored in JSONB (no migration); unset reads false.
     */
    annual_confirmation_include_extras?: boolean;
    /**
     * AnnualRevenueTargetCents is the org's manual annual revenue goal in minor
     * units (Rappen), used by the Finance & Forecast pacing card (projected
     * year-end vs target). Stored in JSONB (no migration). Pointer + omitempty so
     * an unset target is absent from the payload and orgs that never set one are
     * unaffected. A set target must be > 0 (a zero goal is meaningless; clear it
     * by omitting the field instead).
     */
    annual_revenue_target_cents?: number;
    bankName?: string;
    /**
     * BESRID is the organisation's 6-digit BESR-ID from its bank. When set, QR
     * references are built per household (payer and billing month) instead of
     * per invoice split (issue #1756). Changing it recomputes stored references.
     */
    besrId?: string;
    /**
     * BIC is the bank's SWIFT code (8 or 11 characters), printed with the IBAN
     * in the invoice PDF footer.
     */
    bic?: string;
    /**
     * ContactPerson is the billing contact named on the invoice PDF.
     */
    contactPerson?: string;
    creditorCity?: string;
    /**
     * ISO 3166-1 alpha-2 country code (e.g. "CH", "LI", "DE"). Required for a
     * valid Swiss QR Bill payload (line 11 of the SPC block).
     */
    creditorCountry?: string;
    creditorHouseNumber?: string;
    creditorName?: string;
    creditorPostalCode?: string;
    creditorStreet?: string;
    /**
     * Currency code (e.g., "CHF", "EUR", "USD")
     */
    currency: string;
    /**
     * Minimum age in months for daycare enrollment (used for contract date calculations)
     * minimum: 0
     * maximum: 60
     * default: 3
     */
    daycare_min_age_months?: number;
    /**
     * EmailAutoCc toggles the admin auto-CC described above: when true (and
     * EmailCcAddress is set) every outbound invoice and dunning email is CC'd
     * to that address; when false no CC is applied.
     */
    email_auto_cc?: boolean;
    /**
     * Scheduled sending configuration
     */
    email_auto_send?: boolean;
    email_auto_send_day?: models_BillingSettings.email_auto_send_day;
    email_auto_send_time?: string;
    email_auto_send_timezone?: string;
    /**
     * Admin auto-CC: when EmailAutoCc is true and EmailCcAddress is set, every
     * outbound invoice and dunning email is CC'd to EmailCcAddress. The applied
     * CC is snapshotted onto each invoice_email_logs row (cc_email).
     */
    email_cc_address?: string;
    email_hold_rules?: Array<models_EmailHoldRule>;
    email_reply_to?: string;
    /**
     * Email delivery settings
     */
    email_sender_name?: string;
    /**
     * ExitFees is the per-org catalog of selectable exit/termination fees used by
     * the contract-termination workflow. Selected entries become child_extras of
     * type TERMINATION on the final invoice. Stored in JSONB (no migration).
     */
    exit_fees?: Array<models_ExitFee>;
    /**
     * Bank/Payment details (for QR Bill generation)
     */
    iban?: string;
    /**
     * InvoiceDueDateRule sets invoices.due_date at draft generation and
     * supersedes contracts.payment_terms_days (issue #1974). Stored in JSONB
     * (no migration); an organisation that never set it reads 14 days after
     * the invoice date, the term every contract carried before.
     */
    invoice_due_date_rule?: models_InvoiceDueDateRule;
    /**
     * Prefix for invoice numbers (e.g., "INV", "RECH")
     * Only alphanumeric characters, underscores, and hyphens are allowed
     */
    invoice_number_prefix: string;
    /**
     * Minimum age in months for kindergarten enrollment (used for contract date calculations)
     * minimum: 0
     * maximum: 120
     * default: 48
     */
    kindergarten_min_age_months?: number;
    qrIban?: string;
    /**
     * Dynamic services configuration (replaces hardcoded ServiceCodes)
     */
    services: Array<models_Service>;
    /**
     * Settling-in billing defaults (snapshotted onto each plan at creation)
     */
    settling_in_billing?: models_SettlingInBilling;
    /**
     * Discount percentage for the second child
     */
    sibling_discount_2nd_child?: number;
    /**
     * Discount percentage for the third and subsequent children
     */
    sibling_discount_3rd_plus?: number;
    /**
     * Whether to exclude households with subsidised contracts from sibling discounts
     * When enabled, if ANY child in a household has a subsidised contract, no child in that household gets a sibling discount
     * nil defaults to true (exclude by default)
     */
    sibling_discount_exclude_subsidised?: boolean;
    /**
     * SubsidyExpiryAction decides what invoice generation does with a zurich_bf
     * contract version whose Beitragsfaktor or SBU confirmation expired before
     * the billing month (#2004): "warn" generates the invoice with a warning,
     * "hold" skips it. Stored in JSONB (no migration); unset reads "warn".
     */
    subsidy_expiry_action?: models_BillingSettings.subsidy_expiry_action;
    /**
     * SubsidyRoundingAdoptionEnabled lets the subsidy reconciliation adopt the
     * office's rounded child-month amount when it differs from our split by at
     * most SubsidyRoundingAdoptionThresholdCents (issue #1576). Default false.
     */
    subsidy_rounding_adoption_enabled?: boolean;
    /**
     * SubsidyRoundingAdoptionThresholdCents is the inclusive adoption threshold
     * in minor units, 0..500, default 10. A pointer so ApplyDefaults can tell
     * "never set" from an explicit 0 inside the JSONB document. 0 is valid only
     * while adoption is disabled.
     */
    subsidy_rounding_adoption_threshold_cents?: number;
};
export namespace models_BillingSettings {
    export enum email_auto_send_day {
        EOM = 'EOM',
        _1 = '1',
        _2 = '2',
        _3 = '3',
        _4 = '4',
        _5 = '5',
        _6 = '6',
        _7 = '7',
        _8 = '8',
        _9 = '9',
        _10 = '10',
        _11 = '11',
        _12 = '12',
        _13 = '13',
        _14 = '14',
        _15 = '15',
        _16 = '16',
        _17 = '17',
        _18 = '18',
        _19 = '19',
        _20 = '20',
        _21 = '21',
        _22 = '22',
        _23 = '23',
        _24 = '24',
        _25 = '25',
        _26 = '26',
        _27 = '27',
        _28 = '28',
    }
    /**
     * SubsidyExpiryAction decides what invoice generation does with a zurich_bf
     * contract version whose Beitragsfaktor or SBU confirmation expired before
     * the billing month (#2004): "warn" generates the invoice with a warning,
     * "hold" skips it. Stored in JSONB (no migration); unset reads "warn".
     */
    export enum subsidy_expiry_action {
        WARN = 'warn',
        HOLD = 'hold',
    }
}

